import { QUERY_ROUTES, ROUTES } from '@/core/constants/routes'
import { SearchIcon } from 'lucide-react'
import Form from 'next/form'
import { Button } from '../atoms/button'
import { Input } from '../forms/input'
import { useTranslations } from 'next-intl'

export const Search = () => {
  const t = useTranslations()
  return (
    <Form className='relative w-full px-3' action={ROUTES.search}>
      <Input
        placeholder={t('header.Looking for something?')}
        name={QUERY_ROUTES.search.name}
        className='px-8'
      />
      <Button
        color='cyan-blue'
        variant='contained'
        radius='xs'
        type='submit'
        className='absolute top-0 right-3 h-full min-w-10 p-1'
      >
        <SearchIcon className='h-5 w-5 scale-x-[-1]' />
      </Button>
    </Form>
  )
}
